import React from 'react';
import { Select } from '~/libs/ui/atoms/Select';

import { DEFAULT_PER_PAGE, PER_PAGE_SELECT_OPTIONS } from '../constants';

export interface PerPageSelectProps {
	value: number;
	onChange(perPage: number): void;
}

export function PerPageSelect({ value, onChange }: PerPageSelectProps) {
	return (
		<div className='flex items-center gap-2'>
			<label htmlFor='availability-per-page' className='text-sm text-gray-500 whitespace-nowrap'>
				Položek na stránku
			</label>
			<div className='w-20'>
				<Select
					id='availability-per-page'
					value={value.toString()}
					onChange={(next) => onChange(Number(next) || DEFAULT_PER_PAGE)}
					options={PER_PAGE_SELECT_OPTIONS}
				/>
			</div>
		</div>
	);
}
